module.exports = __webpack_public_path__ + "img/code_img.53aa3ac4.png";